import Page from 'commons/page'
import Block from 'components/block'
import ButtonV2 from 'components/button-v2'
import DialogV2 from 'components/dialog-v2'
import { BaseContainer, ButtonWrapper } from 'components/layout'
import { PageTitle, StrongText, Text } from 'components/typography'
import ROUTING_PATH from 'constants/route'
import { useState } from 'react'
import styled from 'styled-components'

const EmailBox = styled.div`
  background-color: ${(p) => p.theme.WHITE};
  border: 1px solid ${(p) => p.theme.BORDER_GRAY};
  border-radius: 4px;
  padding: 16px;
  width: 400px;
  max-width: 100%;
  margin: 0 auto;
  text-align: center;
  box-sizing: border-box;

  @media only screen and (max-width: 440px) {
    width: calc(100% - 32px);
    margin: 0 16px;
  }
`

const EmailLabel = styled(Text)`
  margin-bottom: 8px;
`

const EmailAddress = styled(Text)`
  font-size: ${(p) => p.theme.font.size.l};
  font-weight: 600;

  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    font-size: ${(p) => p.theme.font.size.m};
  }
`

const CenteredButtonWrapper = styled(ButtonWrapper)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const HelpLink = styled.span`
  display: block;
  text-align: center;
  text-decoration: none;
  color: #463e28;
  margin-top: 16px;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`

const HelpDialogBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`

const HelpSection = styled.div<{ isFirst?: boolean; isLast?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: ${(p) => (p.isFirst ? '0' : '20px')};
  padding-bottom: ${(p) => (p.isLast ? '0' : '20px')};
  padding-left: 0;
  padding-right: 0;
`

const HelpDivider = styled.div`
  height: 1px;
  background-color: ${(p) => p.theme.BORDER_GRAY};
  margin: 0;
`

const SignInLink = () => {
  const [showHelpDialog, setShowHelpDialog] = useState(false)

  const handleHelpClick = () => {
    setShowHelpDialog(true)
  }

  const handleCloseDialog = () => {
    setShowHelpDialog(false)
  }

  return (
    <Page title="メール送信完了" type="guest">
      <BaseContainer width="400px" spWidth="100%" col gap="0">
        <PageTitle>メール送信完了</PageTitle>
        <Block>
          <Text align="center">
            ログインURLを送信しました。
            <br />
            メールに記載されているURLから
            <br />
            ログインしてください。
          </Text>
        </Block>
        <Block>
          <EmailBox>
            <EmailLabel align="center">送信したメールアドレス</EmailLabel>
            <EmailAddress align="center">
              {window.localStorage.getItem('emailForSignIn')}
            </EmailAddress>
          </EmailBox>
        </Block>
        <CenteredButtonWrapper>
          <ButtonV2
            size="full"
            radius="full"
            onClick={() => {
              window.location.href = ROUTING_PATH.B0101
            }}
          >
            ログインページへ戻る
          </ButtonV2>
          <HelpLink onClick={handleHelpClick}>
            メールが届かない場合はこちら
          </HelpLink>
        </CenteredButtonWrapper>

        <DialogV2
          show={showHelpDialog}
          onClose={handleCloseDialog}
          styleOptions={{
            position: 'top',
          }}
        >
          <DialogV2.Header
            title="メールが届かない場合"
            showCloseIcon={true}
            titleAlign="center"
            onClose={handleCloseDialog}
          />
          <DialogV2.Body>
            <HelpDialogBody>
              <HelpSection isFirst>
                <StrongText size="lg">
                  迷惑メールフォルダ等に振り分けられている
                </StrongText>
                <Text size="md">
                  Terassからのメールが、迷惑メールファルダやゴミ箱フォルダなどに振り分けられていないかご確認ください。
                </Text>
                <Text size="md">
                  また、Terassからのメールが受信できるように、terass.comのドメイン受信設定をお願いいたします。
                </Text>
              </HelpSection>
              <HelpDivider />
              <HelpSection>
                <StrongText size="lg">
                  誤ったメールアドレスを入力している
                </StrongText>
                <Text size="md">
                  担当エージェントにお伝えしたメールアドレスを入力してください。
                </Text>
                <Text size="md">
                  メールアドレスが分からない場合は、担当エージェントに登録したメールアドレスをご確認ください。
                </Text>
              </HelpSection>
              <HelpDivider />
              <HelpSection isLast>
                <StrongText size="lg">
                  送信されたメールが遅延している
                </StrongText>
                <Text size="md">メールが遅延している可能性があります。</Text>
                <Text size="md">
                  届かない場合は、少し時間を空けてメールが届くかをご確認ください。
                </Text>
              </HelpSection>
            </HelpDialogBody>
          </DialogV2.Body>
        </DialogV2>
      </BaseContainer>
    </Page>
  )
}

export default SignInLink
